import { useEffect, useState } from 'react';
import { ADS_ELIGIBILITY_EVENT, shouldShowAds } from '../utils/adsEligibility';

/** Re-checks premium flag on mount and when storage / eligibility changes. */
export default function useShouldShowAds() {
  const [showAds, setShowAds] = useState(() => shouldShowAds());

  useEffect(() => {
    const sync = () => setShowAds(shouldShowAds());
    sync();
    window.addEventListener('storage', sync);
    window.addEventListener('focus', sync);
    window.addEventListener(ADS_ELIGIBILITY_EVENT, sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('focus', sync);
      window.removeEventListener(ADS_ELIGIBILITY_EVENT, sync);
    };
  }, []);

  return showAds;
}
